import { render, staticRenderFns } from "./OperaMerchantWindow.vue?vue&type=template&id=06647ead&scoped=true"
import script from "./OperaMerchantWindow.vue?vue&type=script&lang=js"
export * from "./OperaMerchantWindow.vue?vue&type=script&lang=js"
import style0 from "./OperaMerchantWindow.vue?vue&type=style&index=0&id=06647ead&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06647ead",
  null
  
)

export default component.exports